import { render, staticRenderFns } from "./MatchManage.vue?vue&type=template&id=108106d9&scoped=true"
import script from "./MatchManage.vue?vue&type=script&lang=js"
export * from "./MatchManage.vue?vue&type=script&lang=js"
import style0 from "./MatchManage.vue?vue&type=style&index=0&id=108106d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108106d9",
  null
  
)

export default component.exports